import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-accountant-info',
  templateUrl: './accountant-info.component.html',
  styleUrls: ['./accountant-info.component.scss']
})
export class AccountantInfoComponent implements OnInit {
  @Input('form') form:FormGroup;
  accountantEmail:FormControl;
  constructor() { }

  ngOnInit() {
    this.accountantEmail = this.form.get('accountant.accountantEmail') as FormControl;
  }

}
